<ng-container *ngIf="orderTtlSeconds">
    <div class="d-inline-flex gap-1 title mr-3  scalable-font">
        <span class="clock-label d-xl-block">
            {{ 'label.countdown' | translate }}:
        </span>
        <span class="clock-countdown">
            {{orderTtlSeconds | timeParse:'S':'MM:SS' }}
        </span>
    </div>
</ng-container>